<ion-app>
  <ion-menu contentId="main-content" class="menu-lateral">
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <div class="logo-container">
          <img src="assets/images/ArrivaLogo.png" alt="Logo" class="menu-logo">
        </div>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list lines="none">
        <!-- Datos del usuario -->
        <ion-item lines="none" class="user-info">
          <ion-label>
            <h2>{{ (currentUser | async)?.full_name }}</h2>
          </ion-label>
        </ion-item>

        <!-- Manual de Usuario -->
        <ion-menu-toggle auto-hide="false">
          <div class="manual-item" (click)="abrirManual()">
            <ion-icon name="help-circle"></ion-icon>
            <span>MANUAL DE USUARIO</span>
          </div>
        </ion-menu-toggle>

        <!-- Cerrar Sesión -->
        <ion-menu-toggle auto-hide="false">
          <div class="logout-item" (click)="logout()">
            <ion-icon name="log-out"></ion-icon>
            <span>CERRAR SESIÓN</span>
          </div>
        </ion-menu-toggle>
      </ion-list>
    </ion-content>
  </ion-menu>

  <div class="ion-page" id="main-content">
    <ion-router-outlet></ion-router-outlet>
  </div>
</ion-app>
